<template>
 <section class="container">
    <div class="title mb-3 text-c title-hr">
      <h6 class="text-c">4大功能升级</h6>
    </div>
    <el-row :gutter="10">
      <el-col :span="24" v-for="(item, index) in v3List" v-bind:key="index">
        <div class="grid-content-v3 bg-purple"
          :style="{ backgroundImage: 'url(' + item.backgroundImage + ')' }"
        >
          <el-row>
            <el-col :span="2" class="text-center">
              <div class="num">{{ item.num }}</div>
            </el-col>
            <el-col :span="22">
              <div class="text-333 title">{{ item.title }}</div>
              <el-row v-for="(group, index1) in item.desc" v-bind:key="index1" >
                <el-col :span="1" class="text-center">
                  <i class="iconfont iconfangkuai text-1e6ce8"></i>
                </el-col>
                <el-col :span="22">
                  <div class="text-333" v-html="group.sub">
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
     <div class="mt-3">
      <div class="title mb-3 text-center title-hr">
        <h6>服务升级 涨价在即</h6>
      </div>
      <div class="serives">
        <el-row :gutter="20" v-for="(item, index2) in v3PriceList" v-bind:key="index2" class="item">
          <el-col :span="9" class="text-center">
            <img :src="item.img" style="width:100%">
          </el-col>
          <el-col :span="15">
            <div class="text-333 title"><span class="">{{ item.title }}</span><span class=" sub">{{ item.sub}}</span></div>
            <!-- <div class="text-333 third">{{ item.desc }}</div> -->
            <div  class="text-333 price">{{item.price}}</div>
            <!-- <a class="btn-custom" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
              限购锁定优惠
            </a> -->
          </el-col>
        </el-row>
     </div>
    </div>
  </section>
  <!-- <section class="price-wrapper">
    <div class="container ">
        <div class="title  text-center">
            <h6 class="text-c">巧记账收费标准</h6>
            <p class="font-12 text-c  color-044fff">Price List</p>
        </div>
        <el-row class="price-list">
            <el-col :span="24" v-for="(item,index) in proList" v-bind:key="index">
                <h6 class="text-fff text-center pt">{{item.tabName}}</h6>
                <el-card class="box-card">
                  <el-row>
                    <el-col :span="12" class="box-item" v-for="(o,index1) in item.tabList" v-bind:key="index1">
                      <div class="font-12">{{o.title}}</div>
                      <div class="font-14"><strong>{{o.third}}</strong></div>
                      <div class="font-10  text-999">{{o.sub}}</div>
                    </el-col>
                  </el-row>
                </el-card>
            </el-col>
            <!-- <el-col :span="24" >
               <h6 class="text-fff  text-center pt">小规模纳税人</h6>
                <el-card class="box-card">
                  <el-row>
                    <el-col :span="12" class="box-item">
                      <div class="font-12">按年购买大礼包</div>
                      <div class="font-16"><strong>记账报税¥188/月</strong></div>
                      <div class="font-10  text-999">含12个月全年抵扣券 两年有效</div>
                    </el-col>
                    <el-col :span="12" class="box-item">
                      <div class="font-12">按月灵活支付</div>
                      <div class="font-16"><strong>记账报税¥208/月</strong></div>
                      <div class="font-10 text-999">即用即付 不限凭证数量</div>
                    </el-col>
                  </el-row>
                </el-card>
            </el-col>
        </el-row>
         <div class="title  text-center">
            <h6 class="text-c">价格低</h6>
            <p class="font-12 text-c  color-044fff">Low Price</p>
        </div>
        <el-row class="table-wrapper">
            <el-col :span="20" :offset="2">
                <el-table
                    :data="tableData"
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                    :show-header="false"
                    >
                    <el-table-column align="center"
                    prop="priceInfo">
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <p class="text-666 font-12">机巧科技根据用户每月实际的凭证数量浮动式收费，当月无票据时最低68元/月；80%的小微企业平均每月代理记账费用不超过100元。</p>
    </div>
</section> -->
</template>
<script>

export default {
  name: 'Lowprice',
  data () {
    return {
      tableData: [{
        priceInfo: '机巧智能记账'
      }, {
        priceInfo: '按当月凭证数浮动式收费'
      }, {
        priceInfo: '纳税申报基础费用仅68元/月'
      }, {
        priceInfo: '大部分客户平均每月低于100元'
      }, {
        priceInfo: '≥68元/月'
      }],
      proList: [
        {
          tabName: '小规模纳税人',
          tabList: [{
            title: '按年购买大礼包',
            sub: '含12个月全额抵扣券 两年有效',
            third: '记账报税88元/月'
          }, {
            title: '按月灵活支付',
            sub: '即用即付 不限凭证数量',
            third: '记账报税108元/月'
          }]
        }, {
          tabName: '一般纳税人',
          tabList: [{
            title: '按年购买大礼包',
            sub: '含12个月全额抵扣券 两年有效',
            third: '记账报税188元/月'
          }, {
            title: '按月灵活支付',
            sub: '即用即付 不限凭证数量',
            third: '记账报税208元/月'
          }]
        }, {
          tabName: '外资企业',
          tabList: [{
            title: '',
            sub: '适合暂无收入/费用/薪资的企业',
            third: '零申报500元/月'
          }, {
            title: '',
            sub: '适合有业务且正常营运的企业',
            third: '记账报税1000元/月'
          }]
        }
      ],
      v3List: [
        {
          num: 1,
          title: '自动抓取票据,智能归类生成凭证',
          backgroundImage: require('../../../assets/image/web-v3-01.png'),
          desc: [
            {
              sub: '无需上传收入发票汇总表'
            },
            {
              sub: '无需上传费用发票,无需勾选费用类别'
            },
            {
              sub: '自动抓取社保缴费单及缴税凭证'
            },
            {
              sub: '自动抓取银行签约对账单及回单'
            },
            {
              sub: '仅作确认即可'
            }
          ]
        },
        {
          num: 2,
          title: '支持零申报企业一键托管',
          backgroundImage: require('../../../assets/image/web-v3-02.png'),
          desc: [
            {
              sub: '勾选零申报托管'
            },
            {
              sub: '全程自动申报'
            },
            {
              sub: '无需确认'
            }
          ]
        },
        {
          num: 3,
          title: '权委托服务模式支持',
          backgroundImage: require('../../../assets/image/web-v3-03.png'),
          desc: [
            {
              sub: '记账、开票、人事、企银直连、<br>零星服务全托'
            },
            {
              sub: '自动完成一般纳税人进项认证'
            }
          ]
        },
        {
          num: 4,
          title: '虚拟CFO小巧提供咨询支持',
          backgroundImage: require('../../../assets/image/web-v3-04.png'),
          desc: [
            {
              sub: '专属群添置CFO智能服务'
            },
            {
              sub: '提供报表分析、预算成本控制等<br>财务咨询解答'
            }
          ]
        }
      ],
      hotImg: require('../../../assets/image/img-hot.png'),
      v3PriceList: [{
        title: '小规模纳税人',
        sub: '记账报税',
        // desc: '涨价后：1596元/年 108元/月',
        price: '¥1596元/年',
        img: require('../../../assets/image/web-v3-05.png')
      }, {
        title: '一般纳税人',
        sub: '记账报税',
        // desc: '涨价后：2916元/年 218元/月',
        price: '¥2916元/年',
        img: require('../../../assets/image/web-v3-06.png')

      }]
    }
  },
  mounted () {
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex === 0 || rowIndex === 2 || rowIndex === 4) {
        return 'success-row'
      } else if (rowIndex === 1 || rowIndex === 3 || rowIndex === 5) {
        return 'warning-row'
      }
      return ''
    }
  }
}
</script>
<style>
.el-table .warning-row {
    background: #e7f0fd;
    color: #044fff
}

.el-table .success-row {
    background: #044fff;
    color: #fff;
}
.table-wrapper{
    margin-bottom: 1rem ;
}
.price-list{
  background: #044fff;
  border-radius: 15px;
  padding: 10px 10px 25px;
}
.box-card{
  padding: 10px 0;
}
.box-item{
  border-right: 1px solid #ddd;
  padding: 0 10px;

}
.box-item:last-child{
  border-right:0;
  text-indent: 10px;
}
/*四大新功能*/
.grid-content-v3 {
  height: 200px;
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 20px 20px;
}
.grid-content-v3 .num {
  width: 24px;
  height: 24px;
  text-align: center;
  background: #013ee4;
  color: #fff;
  border-radius: 5px;
  border-bottom-right-radius: 0;
  border: 1px solid #a7e8f8;
  line-height: 24px;
}
.grid-content-v3 .title {
  font-weight: 600;
}
.grid-content-v3 .desc {
  font-weight: 600;
  font-size: 12px;
}
.serives{
  background: #013ee4;
  border-radius: 5px;
  padding: 10px 20px;
}
.serives .item{
  background: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
  padding:10px;

}
.serives  .title{
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin-top: 0;
}
.serives  .title .sub{
  font-size: 12px;
  color: #013ee4;
  font-weight: 400;

}
.serives  .third{
  font-size: 12px;
  color: #999;
}
.serives  .price{
  font-size:16px;
  color: rgb(248, 101, 2);
  font-weight: 700;
  margin-top:2px

}
.serives  .btn-custom{
  display: inline-block;
  text-align: center;
  width: 100px ;
  height:28px ;
  line-height: 28px;
  padding: 0;
  border-radius:15px;
  background-image: linear-gradient(to right, #c436fc, #013ee4);
  transition: background-image 0.3s ease;
  color:#fff;
  font-size:12px;
  margin-left: 0;

}
</style>



// WEBPACK FOOTER //
// src/pages/mhome/components/Lowprice.vue